module.exports = __webpack_public_path__ + "static/media/cash-out.9f6218f1.svg";